/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

export enum PeriodDepreciationCalculated {
  Monthly = 0,
  Daily_YearsAreEqual = 1,
  Daily_DaysAreEqual = 2,
  Yearly = 3,
}
